import { Button, TableCell, TableRow } from '@mui/material'
import Confirm from 'components/Dialog'
import EnrollmentCount from 'pages/Scheduling/EnrollmentCount'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

export default function SchedulingEnrollStudentListItem({ item, destroyEnrollment, selected }) {
  const { t } = useTranslation()
  const [confirm, setConfirm] = useState({ status: false, id: null, courseSessionId: null })
  const academicYearMarkingPeriods = useSelector(state => state.session?.academicYear?.markingPeriods)
  const persons = useSelector(state => state?.scheduling?.courseSessionEnrollment?.person)
  console.log('selected', selected

  )
  const getTerm = mp => {
    if (academicYearMarkingPeriods?.length === 1 && mp?.length === 1) {
      return 'Summer'
    } else if (mp?.length === academicYearMarkingPeriods?.length) {
      return 'Full Year'
    } else {
      return mp?.map(item => item.name).toString()
    }
  }

  const getTeacherName = session => {
    const lastname = persons?.find(p => p.id === session?.teacherSchoolEnrollmentId)?.person?.lastName
    const firstname = persons?.find(p => p.id === session?.teacherSchoolEnrollmentId)?.person?.firstName
    if (lastname && firstname) {
      return `${lastname}, ${firstname}`
    }
    return null
  }

  return (
    <>
      <TableRow hover>
        <TableCell>{item?.courseSession?.course?.name}</TableCell>
        <TableCell>{item?.courseSession?.name}</TableCell>
        <TableCell>{getTeacherName(item)}</TableCell>
        <TableCell>{getTerm(item?.courseSession?.markingPeriods)}</TableCell>
        <TableCell>
          <EnrollmentCount enrolled={item?.enrollmentCount} quota={item?.courseSession?.quota} />
        </TableCell>
        <TableCell>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => setConfirm({ status: true, id: item?.id, courseSessionId: item?.courseSession?.id })}
          >
            {t('Unenroll')}
          </Button>
        </TableCell>
      </TableRow>
      <Confirm
        open={confirm.status}
        onClose={() => setConfirm({ status: false, id: null, courseSessionId: null })}
        onConfirm={() => {
          destroyEnrollment(confirm)
          setConfirm({ status: false, id: null, courseSessionId: null })
        }}
        dialogTitle={t('Unenroll Student')}
        message={`Are you sure you want to unenroll ${selected?.person?.firstName} ${selected?.person?.lastName} from ${item?.courseSession?.course?.name}?`}
      />
    </>
  )
}
